<template>
    <div id="app" class="primo">
        <transition enter-active-class="animated fadeIn fast" leave-active-class="animated fadeOut fast" mode="out-in">
            <router-view v-if="this.authenticated"></router-view>

            <div class="horizontal-align-ab" v-else>
                <FulfillingBouncingCircleSpinner v-if="loadingMsg === null"
                    :animation-duration="2500"
                    :size="45"
                    :color="'#232F4B'">
                </FulfillingBouncingCircleSpinner>
                <div class="m-t-10">{{ loadingMsg }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
// /* global Helpers */
import { windowMessaging } from '@/components/mixins/windowMessaging'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

export default {
    name: 'app',
    components: {FulfillingBouncingCircleSpinner},
    mixins: [windowMessaging],
    data () {
        return {
            user: null,
            token: null,
            refreshToken: false,
            authenticated: false,
            loadingMsg: null,
            template: null
        }
    },
    watch: {
        '$route.path': function () {
            this.checkAuthentication()
        }
    },
    created () {
        this.refreshToken = true
        this.checkAuthentication()
        this.windowMsgLoaded()
        this.setAppVars()

        const unwatch = this.$watch(
            () => this.$route,
            (route, prevRoute) => {
                this.setAppVars()
                unwatch()
            }
        )

        window.addEventListener('message', (e) => {
            // Window Resize
            if (e.data.type === 'url') {
                this.setUrl(e.data.url)
            }
        })
    },
    methods: {
        setUrl (url) {
            if (this.$store) {
                this.$store.commit('pageUrl', url)
            } else {
                setTimeout(() => { this.setUrl(url) }, 500)
            }
        },
        checkAuthentication () {
            if (this.refreshToken === true || !this.$auth.check()) {
                this.authenticate()
            } else {
                this.authenticated = true
            }
        },
        authenticate () {
            if (this.$route.query.user && this.$route.query.token) {
                this.$store.commit('user', this.$route.query.user)
                this.$store.commit('token', this.$route.query.token)
                this.user = this.$route.query.user
                this.token = this.$route.query.token

                this.$auth.login({
                    params: {
                        user: this.user,
                        token: this.token
                    },
                    success: function (res) {
                        this.authenticated = true
                    },
                    error: function (error) {
                        console.log(error)
                        this.authenticated = false
                        this.loadingMsg = 'Sorry, we could not verify your account'
                    },
                    rememberMe: true,
                    redirect: false,
                    fetchUser: true
                })
            } else if (this.$auth.check()) {
                this.authenticated = true
            }
        },
        setAppVars () {
            let config = this.$store.state.config

            // Mode
            if (this.$route.query.mode !== undefined) {
                this.$store.commit('mode', this.$route.query.mode)
            }

            // Config
            config.hideSideNav = (this.$route.query.hideSideNav === 'true')
            config.hideDeepLinks = (this.$route.query.hideDeepLinks === 'true')

            this.$store.commit('config', config)
        }
    }
}

// Get Current Route - If it's not the login route >
// Check Auth, login or redirect if needed
</script>

<style src="./assets/styles/app.scss" lang="scss"></style>
<style lang="scss" scoped>
    @-webkit-keyframes spin {
        0%  {-webkit-transform: rotate(0deg);}
        100% {-webkit-transform: rotate(360deg);}
    }

    div.horizontal-align-ab {
        font-size: 1.3em;
        padding-left: 1.7em;
        padding-top: 10%;
        padding-bottom: 90%;
        color: #000000;

        span {
            left: 0;
            color: #bbbbbb;
            font-size: 1.2em;
            padding: .1em;
            position: absolute;
            -webkit-animation: spin .7s infinite linear;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?140a3b1a